-- | GENERATED by tools/sync-paraphrase.mjs - do not edit.
-- |
-- | Source: data/es-paraphrase.csv (92 prompts).
module Flashcards.Data.Paraphrase.Spanish
  ( prompts
  )
  where

import Flashcards.Verbs.Paraphrase (Prompt, Trap(..))
import Flashcards.Verbs.Table (Person(..), Tense(..))

-- | In the corpus's order, which is the order their items are first asked in.
prompts :: Array Prompt
prompts =
  [ { id: "door-open", asked: "How would you tell me the door is open?"
    , model: "La puerta está abierta."
    , verb: "estar", tense: Present, person: Sg3
    , trap: OnVerb, against: "ser"
    }
  , { id: "sick-today", asked: "How might you tell me you're sick today?"
    , model: "Hoy estoy enfermo."
    , verb: "estar", tense: Present, person: Sg1
    , trap: OnVerb, against: "ser"
    }
  , { id: "brother-tall", asked: "How would you tell me your brother is tall?"
    , model: "Mi hermano es alto."
    , verb: "ser", tense: Present, person: Sg3
    , trap: OnVerb, against: "estar"
    }
  , { id: "party-house", asked: "How would you tell me the party is at your house?"
    , model: "La fiesta es en mi casa."
    , verb: "ser", tense: Present, person: Sg3
    , trap: OnVerb, against: "estar"
    }
  , { id: "at-home", asked: "How would you tell me you're at home?"
    , model: "Estoy en casa."
    , verb: "estar", tense: Present, person: Sg1
    , trap: OnVerb, against: "ser"
    }
  , { id: "where-am-i", asked: "How might you ask me where I am?"
    , model: "¿Dónde estás?"
    , verb: "estar", tense: Present, person: Sg2
    , trap: OnVerb, against: "ser"
    }
  , { id: "sister-doctor", asked: "How would you tell me your sister is a doctor?"
    , model: "Mi hermana es médica."
    , verb: "ser", tense: Present, person: Sg3
    , trap: OnVerb, against: "estar"
    }
  , { id: "children-bored", asked: "How might you say the children are bored?"
    , model: "Los niños están aburridos."
    , verb: "estar", tense: Present, person: Pl3
    , trap: OnVerb, against: "ser"
    }
  , { id: "we-ready", asked: "How would you tell me we're ready?"
    , model: "Estamos listos."
    , verb: "estar", tense: Present, person: Pl1
    , trap: OnVerb, against: "ser"
    }
  , { id: "one-o-clock", asked: "How would you say it's one o'clock?"
    , model: "Es la una."
    , verb: "ser", tense: Present, person: Sg3
    , trap: OnVerb, against: "estar"
    }
  , { id: "from-mexico", asked: "How would you tell me you're from Mexico?"
    , model: "Soy de México."
    , verb: "ser", tense: Present, person: Sg1
    , trap: OnVerb, against: "estar"
    }
  , { id: "food-good", asked: "How might you say the food is really good today?"
    , model: "Hoy la comida está muy buena."
    , verb: "estar", tense: Present, person: Sg3
    , trap: OnVerb, against: "ser"
    }
  , { id: "city-far", asked: "How would you tell me the city is far from here?"
    , model: "La ciudad está lejos de aquí."
    , verb: "estar", tense: Present, person: Sg3
    , trap: OnVerb, against: "ser"
    }
  , { id: "went-store-weekly", asked: "How would you tell me you went to the store every week?"
    , model: "Iba a la tienda cada semana."
    , verb: "ir", tense: Imperfect, person: Sg1
    , trap: OnTense, against: "preterite"
    }
  , { id: "went-mexico", asked: "How might you tell me you went to Mexico last year?"
    , model: "El año pasado fui a México."
    , verb: "ir", tense: Preterite, person: Sg1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "sister-had-son", asked: "How would you tell me your sister had a son yesterday?"
    , model: "Ayer mi hermana tuvo un hijo."
    , verb: "tener", tense: Preterite, person: Sg3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "parents-met-madrid", asked: "How might you tell me your parents met in Madrid?"
    , model: "Mis padres se conocieron en Madrid."
    , verb: "conocer", tense: Preterite, person: Pl3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "had-dog", asked: "How would you tell me you had a dog as a kid?"
    , model: "De niño, tenía un perro."
    , verb: "tener", tense: Imperfect, person: Sg1
    , trap: OnTense, against: "preterite"
    }
  , { id: "played-street", asked: "How would you tell me you played in the street every day as a kid?"
    , model: "De niño, jugaba en la calle todos los días."
    , verb: "jugar", tense: Imperfect, person: Sg1
    , trap: OnTense, against: "preterite"
    }
  , { id: "played-two-hours", asked: "How might you tell me you played for two hours yesterday?"
    , model: "Ayer jugué dos horas."
    , verb: "jugar", tense: Preterite, person: Sg1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "read-whole-book", asked: "How would you tell me you read the whole book last night?"
    , model: "Anoche leí todo el libro."
    , verb: "leer", tense: Preterite, person: Sg1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "baby-slept-hours", asked: "How would you tell me the baby slept ten hours last night?"
    , model: "Anoche el bebé durmió diez horas."
    , verb: "dormir", tense: Preterite, person: Sg3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "reading-when-called", asked: "How would you tell me you were reading when I called?"
    , model: "Leía cuando me llamaste."
    , verb: "leer", tense: Imperfect, person: Sg1
    , trap: OnTense, against: "preterite"
    }
  , { id: "where-met-wife", asked: "How would you ask me where I met my wife?"
    , model: "¿Dónde conociste a tu esposa?"
    , verb: "conocer", tense: Preterite, person: Sg2
    , trap: OnTense, against: "imperfect"
    }
  , { id: "slept-badly", asked: "How would you tell me you slept badly last night?"
    , model: "Anoche dormí mal."
    , verb: "dormir", tense: Preterite, person: Sg1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "brother-couldnt-read", asked: "How would you tell me your brother didn't know how to read as a kid?"
    , model: "De niño, mi hermano no sabía leer."
    , verb: "saber", tense: Imperfect, person: Sg3
    , trap: OnTense, against: "preterite"
    }
  , { id: "mother-read-nightly", asked: "How would you tell me your mother read to you every night as a kid?"
    , model: "Cuando era niño, mi madre me leía todas las noches."
    , verb: "leer", tense: Imperfect, person: Sg3
    , trap: OnTense, against: "preterite"
    }
  , { id: "found-out-truth", asked: "How would you tell me you found out the truth yesterday?"
    , model: "Ayer supe la verdad."
    , verb: "saber", tense: Preterite, person: Sg1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "already-knew-answer", asked: "How might you tell me you already knew the answer?"
    , model: "Ya sabía la respuesta."
    , verb: "saber", tense: Imperfect, person: Sg1
    , trap: OnTense, against: "preterite"
    }
  , { id: "children-played-afternoons", asked: "How would you tell me the children played in the street every afternoon?"
    , model: "Los niños jugaban en la calle todas las tardes."
    , verb: "jugar", tense: Imperfect, person: Pl3
    , trap: OnTense, against: "preterite"
    }
  , { id: "met-brother-party", asked: "How would you tell me you met my brother at a party?"
    , model: "Conocí a tu hermano en una fiesta."
    , verb: "conocer", tense: Preterite, person: Sg1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "went-sea-summer", asked: "How would you tell me you and your sister always went to the sea in the summer?"
    , model: "Mi hermana y yo siempre íbamos al mar en verano."
    , verb: "ir", tense: Imperfect, person: Pl1
    , trap: OnTense, against: "preterite"
    }
  , { id: "grandparents-came", asked: "How would you tell me your grandparents always came on Sundays?"
    , model: "Mis abuelos siempre venían los domingos."
    , verb: "venir", tense: Imperfect, person: Pl3
    , trap: OnTense, against: "preterite"
    }
  , { id: "where-went-last-night", asked: "How would you ask me where I went last night?"
    , model: "¿Adónde fuiste anoche?"
    , verb: "ir", tense: Preterite, person: Sg2
    , trap: OnTense, against: "imperfect"
    }
  , { id: "car-problem-morning", asked: "How would you tell me you had a problem with the car this morning?"
    , model: "Esta mañana tuve un problema con el coche."
    , verb: "tener", tense: Preterite, person: Sg1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "friends-went-sea", asked: "How might you tell me your friends went to the sea yesterday?"
    , model: "Ayer mis amigos fueron al mar."
    , verb: "ir", tense: Preterite, person: Pl3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "grandfather-always-dog", asked: "How would you tell me your grandfather always had a dog in the house?"
    , model: "Mi abuelo siempre tenía un perro en la casa."
    , verb: "tener", tense: Imperfect, person: Sg3
    , trap: OnTense, against: "preterite"
    }
  , { id: "many-friends-school", asked: "How might you ask me if I had many friends at school?"
    , model: "¿Tenías muchos amigos en la escuela?"
    , verb: "tener", tense: Imperfect, person: Sg2
    , trap: OnTense, against: "preterite"
    }
  , { id: "what-played-kid", asked: "How might you ask me what I played as a kid?"
    , model: "¿A qué jugabas de niño?"
    , verb: "jugar", tense: Imperfect, person: Sg2
    , trap: OnTense, against: "preterite"
    }
  , { id: "kids-played-all-afternoon", asked: "How might you tell me the children played all afternoon yesterday?"
    , model: "Ayer los niños jugaron toda la tarde."
    , verb: "jugar", tense: Preterite, person: Pl3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "father-read-paper", asked: "How might you tell me your father read the newspaper this morning?"
    , model: "Esta mañana mi padre leyó el periódico."
    , verb: "leer", tense: Preterite, person: Sg3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "brother-played-well", asked: "How would you tell me your brother played very well last night?"
    , model: "Anoche mi hermano jugó muy bien."
    , verb: "jugar", tense: Preterite, person: Sg3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "grandparents-read-paper", asked: "How might you tell me your grandparents read the newspaper every morning?"
    , model: "Mis abuelos leían el periódico todas las mañanas."
    , verb: "leer", tense: Imperfect, person: Pl3
    , trap: OnTense, against: "preterite"
    }
  , { id: "had-to-leave-early", asked: "How might you tell me we had to leave early yesterday?"
    , model: "Ayer tuvimos que salir temprano."
    , verb: "tener", tense: Preterite, person: Pl1
    , trap: OnTense, against: "imperfect"
    }
  , { id: "slept-well-last-night", asked: "How might you ask me if I slept well last night?"
    , model: "¿Dormiste bien anoche?"
    , verb: "dormir", tense: Preterite, person: Sg2
    , trap: OnTense, against: "imperfect"
    }
  , { id: "sister-found-out-news", asked: "How would you tell me your sister found out the news this morning?"
    , model: "Esta mañana mi hermana supo la noticia."
    , verb: "saber", tense: Preterite, person: Sg3
    , trap: OnTense, against: "imperfect"
    }
  , { id: "when-found-out", asked: "How might you ask me when I found out?"
    , model: "¿Cuándo lo supiste?"
    , verb: "saber", tense: Preterite, person: Sg2
    , trap: OnTense, against: "imperfect"
    }
  , { id: "parents-already-knew", asked: "How might you tell me your parents already knew everything?"
    , model: "Mis padres ya lo sabían todo."
    , verb: "saber", tense: Imperfect, person: Pl3
    , trap: OnTense, against: "preterite"
    }
  , { id: "parents-went-work", asked: "How might you tell me your parents went to work every day by car?"
    , model: "Mis padres iban al trabajo en coche todos los días."
    , verb: "ir", tense: Imperfect, person: Pl3
    , trap: OnTense, against: "preterite"
    }
  , { id: "read-my-letter", asked: "How would you ask me if I read your letter?"
    , model: "¿Leíste mi carta?"
    , verb: "leer", tense: Preterite, person: Sg2
    , trap: OnTense, against: "imperfect"
    }
  , { id: "grandfather-came-summers", asked: "How would you tell me your grandfather came to your house every summer?"
    , model: "Mi abuelo venía a casa cada verano."
    , verb: "venir", tense: Imperfect, person: Sg3
    , trap: OnTense, against: "preterite"
    }
  , { id: "always-came-here-kid", asked: "How might you tell me you always came here as a kid?"
    , model: "De niño, siempre venía aquí."
    , verb: "venir", tense: Imperfect, person: Sg1
    , trap: OnTense, against: "preterite"
    }
  , { id: "hope-arrive-on-time", asked: "How might you tell me you hope I arrive on time?"
    , model: "Espero que llegues a tiempo."
    , verb: "llegar", tense: Subjunctive, person: Sg2
    , trap: OnTense, against: "present"
    }
  , { id: "know-someone-can-help", asked: "How might you tell me you know someone who can help you?"
    , model: "Conozco a alguien que me puede ayudar."
    , verb: "poder", tense: Present, person: Sg3
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "necessary-do-something", asked: "How might you tell me it's necessary that we do something?"
    , model: "Es necesario que hagamos algo."
    , verb: "hacer", tense: Subjunctive, person: Pl1
    , trap: OnTense, against: "present"
    }
  , { id: "need-you-put-books", asked: "How would you tell me you need me to put the books on the table?"
    , model: "Necesito que pongas los libros en la mesa."
    , verb: "poner", tense: Subjunctive, person: Sg2
    , trap: OnTense, against: "present"
    }
  , { id: "brother-says-coming", asked: "How might you tell me your brother says he's coming tomorrow?"
    , model: "Mi hermano dice que viene mañana."
    , verb: "venir", tense: Present, person: Sg3
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "sorry-cant-come", asked: "How would you tell me you're sorry I can't come?"
    , model: "Siento que no puedas venir."
    , verb: "poder", tense: Subjunctive, person: Sg2
    , trap: OnTense, against: "present"
    }
  , { id: "important-homework", asked: "How would you tell me it's important that they do their homework?"
    , model: "Es importante que hagan la tarea."
    , verb: "hacer", tense: Subjunctive, person: Pl3
    , trap: OnTense, against: "present"
    }
  , { id: "call-when-home", asked: "How would you tell me you'll call me when you get home?"
    , model: "Te llamo cuando llegue a casa."
    , verb: "llegar", tense: Subjunctive, person: Sg1
    , trap: OnTense, against: "present"
    }
  , { id: "always-do-when-time", asked: "How would you tell me you always do it when you have time?"
    , model: "Siempre lo hago cuando tengo tiempo."
    , verb: "tener", tense: Present, person: Sg1
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "want-brother-come", asked: "How might you tell me you want your brother to come?"
    , model: "Quiero que venga mi hermano."
    , verb: "venir", tense: Subjunctive, person: Sg3
    , trap: OnTense, against: "present"
    }
  , { id: "better-say-nothing", asked: "How might you tell me it's better that we don't say anything?"
    , model: "Es mejor que no digamos nada."
    , verb: "decir", tense: Subjunctive, person: Pl1
    , trap: OnTense, against: "present"
    }
  , { id: "hope-its-a-boy", asked: "How would you tell me you hope it's a boy?"
    , model: "Espero que sea un niño."
    , verb: "ser", tense: Subjunctive, person: Sg3
    , trap: OnTense, against: "present"
    }
  , { id: "know-theyre-coming", asked: "How might you tell me you know they're coming tomorrow?"
    , model: "Sé que vienen mañana."
    , verb: "venir", tense: Present, person: Pl3
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "want-him-set", asked: "How would you tell me you want him to set the table?"
    , model: "Quiero que ponga la mesa."
    , verb: "poner", tense: Subjunctive, person: Sg3
    , trap: OnTense, against: "present"
    }
  , { id: "do-when-time", asked: "How would you tell me you'll do it when you have time?"
    , model: "Lo hago cuando tenga tiempo."
    , verb: "tener", tense: Subjunctive, person: Sg1
    , trap: OnTense, against: "present"
    }
  , { id: "true-parents-coming", asked: "How would you tell me it's true that your parents are coming?"
    , model: "Es verdad que vienen mis padres."
    , verb: "venir", tense: Present, person: Pl3
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "tell-me-truth", asked: "How would you tell me you don't think I'm telling you everything?"
    , model: "No creo que me digas todo."
    , verb: "decir", tense: Subjunctive, person: Sg2
    , trap: OnTense, against: "present"
    }
  , { id: "possible-theyre-hungry", asked: "How might you tell me it's possible they're hungry?"
    , model: "Es posible que tengan hambre."
    , verb: "tener", tense: Subjunctive, person: Pl3
    , trap: OnTense, against: "present"
    }
  , { id: "eat-when-parents-arrive", asked: "How would you tell me we always eat when your parents arrive?"
    , model: "Siempre comemos cuando llegan mis padres."
    , verb: "llegar", tense: Present, person: Pl3
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "hope-good-day", asked: "How would you tell me you hope I have a good day?"
    , model: "Espero que tengas un buen día."
    , verb: "tener", tense: Subjunctive, person: Sg2
    , trap: OnTense, against: "present"
    }
  , { id: "want-you-do-today", asked: "How would you tell me you want me to do it today?"
    , model: "Quiero que lo hagas hoy."
    , verb: "hacer", tense: Subjunctive, person: Sg2
    , trap: OnTense, against: "present"
    }
  , { id: "eat-when-parents-come", asked: "How would you tell me we'll eat when your parents come?"
    , model: "Comemos cuando vengan mis padres."
    , verb: "venir", tense: Subjunctive, person: Pl3
    , trap: OnTense, against: "present"
    }
  , { id: "think-we-can-go", asked: "How would you tell me you think we can go?"
    , model: "Pienso que podemos ir."
    , verb: "poder", tense: Present, person: Pl1
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "prefer-they-put-food", asked: "How might you tell me you'd rather they put the food on the table?"
    , model: "Prefiero que pongan la comida en la mesa."
    , verb: "poner", tense: Subjunctive, person: Pl3
    , trap: OnTense, against: "present"
    }
  , { id: "want-us-friends", asked: "How might you tell me you want us to be friends?"
    , model: "Quiero que seamos amigos."
    , verb: "ser", tense: Subjunctive, person: Pl1
    , trap: OnTense, against: "present"
    }
  , { id: "looking-someone-help", asked: "How might you tell me you're looking for someone who can help you?"
    , model: "Busco a alguien que me pueda ayudar."
    , verb: "poder", tense: Subjunctive, person: Sg3
    , trap: OnTense, against: "present"
    }
  , { id: "believe-its-true", asked: "How would you tell me you think it's true?"
    , model: "Creo que es verdad."
    , verb: "ser", tense: Present, person: Sg3
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "hope-we-can-go", asked: "How would you tell me you hope we can go?"
    , model: "Espero que podamos ir."
    , verb: "poder", tense: Subjunctive, person: Pl1
    , trap: OnTense, against: "present"
    }
  , { id: "leave-before-others-arrive", asked: "How would you tell me we'll leave before the others arrive?"
    , model: "Salimos antes de que lleguen los otros."
    , verb: "llegar", tense: Subjunctive, person: Pl3
    , trap: OnTense, against: "present"
    }
  , { id: "want-her-tell-truth", asked: "How would you tell me you want her to tell you the truth?"
    , model: "Quiero que me diga la verdad."
    , verb: "decir", tense: Subjunctive, person: Sg3
    , trap: OnTense, against: "present"
    }
  , { id: "call-when-home-daily", asked: "How would you tell me you call me when you get home every day?"
    , model: "Te llamo cuando llego a casa todos los días."
    , verb: "llegar", tense: Present, person: Sg1
    , trap: OnTense, against: "subjunctive"
    }
  , { id: "dont-think-true", asked: "How might you tell me you don't think it's true?"
    , model: "No creo que sea verdad."
    , verb: "ser", tense: Subjunctive, person: Sg3
    , trap: OnTense, against: "present"
    }
  , { id: "possible-come-tomorrow", asked: "How might you tell me it's possible you'll come here tomorrow?"
    , model: "Es posible que venga aquí mañana."
    , verb: "venir", tense: Subjunctive, person: Sg1
    , trap: OnTense, against: "present"
    }
  , { id: "know-this-city", asked: "How might you tell me you know this city?"
    , model: "Conozco esta ciudad."
    , verb: "conocer", tense: Present, person: Sg1
    , trap: OnVerb, against: "saber"
    }
  , { id: "know-drive", asked: "How would you tell me you know how to drive?"
    , model: "Sé conducir."
    , verb: "saber", tense: Present, person: Sg1
    , trap: OnVerb, against: "conocer"
    }
  , { id: "know-where-hotel", asked: "How might you ask me if I know where the hotel is?"
    , model: "¿Sabes dónde está el hotel?"
    , verb: "saber", tense: Present, person: Sg2
    , trap: OnVerb, against: "conocer"
    }
  , { id: "nobody-knows-name", asked: "How would you tell me nobody knows his name?"
    , model: "Nadie sabe su nombre."
    , verb: "saber", tense: Present, person: Sg3
    , trap: OnVerb, against: "conocer"
    }
  , { id: "know-sister", asked: "How would you ask me if I know your sister?"
    , model: "¿Conoces a mi hermana?"
    , verb: "conocer", tense: Present, person: Sg2
    , trap: OnVerb, against: "saber"
    }
  , { id: "parents-know-family", asked: "How would you tell me my parents know your family?"
    , model: "Tus padres conocen a mi familia."
    , verb: "conocer", tense: Present, person: Pl3
    , trap: OnVerb, against: "saber"
    }
  , { id: "we-know-late", asked: "How would you tell me we know it's late?"
    , model: "Sabemos que es tarde."
    , verb: "saber", tense: Present, person: Pl1
    , trap: OnVerb, against: "conocer"
    }
  ]
